export default __webpack_public_path__ + "static/media/resumeanalyzer.a27b4b80.png";